export const mileModalList = [
  { label: 'Less than 50 miles' },
  { label: '51-200 miles' },
  { label: '201-500 miles' },
  { label: 'More than 500 miles' },
];

export const classModalList = [
  { label: 'Class 2a: 6,001-8,500 pounds (2,722-3,856 kg)' },
  { label: 'Class 2b: 8,501-10,000 pounds (3,856-4,536 kg)' },
  { label: 'Class 3: 10,001-14,000 pounds (4,536-6,350 kg)' },
  { label: 'Class 4: 14,001-16,000 pounds (6,351-7,257 kg)' },
  { label: 'Class 5: 16,001-19,500 pounds (7,258-8,845 kg)' },
  { label: 'Class 6: 19,501-26,000 pounds (8,846-11,793 kg)' },
  { label: 'Class 7: 26,001-33,000 pounds (11,794-14,969 kg)' },
  { label: 'Class 8: 33,001 pounds (14,969 kg) +' },
];

export const trailerList = [
  { label: '4 Bolster Trailer' },
  { label: 'Auto Transporter Trailer' },
  { label: 'Curtain Van Trailer' },
  { label: 'Dry Bulk Trailer' },
  { label: 'Dry Van Trailer' },
  { label: 'Dump Trailer' },
  { label: 'Flatbed Trailer' },
  { label: 'Gooseneck Trailer' },
  { label: 'Intermodal Container Hauler Trailer' },
  { label: 'Low Boy Trailer' },
  { label: 'Pole Trailer' },
  { label: 'Refrigerated Van Trailer' },
  { label: 'Step Deck Trailer' },
  { label: 'Tilt Deck Trailer' },
  { label: 'Utility Trailer' },
];

export const truckList = [
  { label: 'Box Truck' },
  { label: 'Dump Truck' },
  { label: 'Flatbed Truck' },
  { label: 'Pickup' },
  { label: 'Sprinter/Cargo Van' },
  { label: 'Stake Truck' },
  { label: 'Straight Truck' },
  { label: 'Tractor' },
];
